<p-table
  [value]="entries"
  [loading]="loading"
  [paginator]="true"
  [rows]="rows"
  [rowsPerPageOptions]="[10, 20, 50, 100]"
  responsiveLayout="scroll"
  styleClass="p-datatable-sm"
  currentPageReportTemplate="{first} bis {last} von {totalRecords}"
  [showCurrentPageReport]="true"
>
  <ng-template pTemplate="header">
    <tr>
      <th
        class="col-status"
        pTooltip="Aufzeichnung vorhanden/fehlt"
        tooltipPosition="bottom"
      >
        <i class="pi pi-video"></i>
      </th>
      @if (showClassbook) {
        <th
          class="col-status"
          pTooltip="Klassenbuch-Eintrag vorhanden/fehlt"
          tooltipPosition="bottom"
        >
          <i class="pi pi-book"></i>
        </th>
      }
      <th style="width: 15%" pSortableColumn="date">
        Datum <p-sortIcon field="date"></p-sortIcon>
      </th>
      <th style="width: 10%">Uhrzeit</th>
      <th style="width: 22%" pSortableColumn="courseName">
        Kursname <p-sortIcon field="courseName"></p-sortIcon>
      </th>
      <th style="width: 33%" pSortableColumn="topic">
        Thema <p-sortIcon field="topic"></p-sortIcon>
      </th>
      <th style="width: 20%">Meeting</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-entry>
    <tr [class.today-row]="isToday(entry)">
      <td class="col-status">
        <!-- status-cell in beiden Spalten: sonst sitzt das reine Icon auf der Textlinie,
             der Knopf daneben aber in seiner eigenen Box — die Icons stünden versetzt. -->
        <div class="status-cell">
          <i
            class="pi pi-video status-icon"
            [class.status-icon--ok]="entry.hasRecording"
            [class.status-icon--missing]="!entry.hasRecording"
            [pTooltip]="
              entry.hasRecording
                ? 'Aufzeichnung vorhanden'
                : 'Keine Aufzeichnung vorhanden'
            "
            tooltipPosition="right"
          ></i>
        </div>
      </td>
      @if (showClassbook) {
        <td class="col-status">
          <!-- Ohne Klassenbuchpflicht bleibt die Zelle leer, statt einen toten Knopf zu zeigen. -->
          <div class="status-cell">
            @if (entry.classbookEnabled) {
              <p-button
                [rounded]="true"
                [text]="true"
                icon="pi pi-book"
                [styleClass]="
                  entry.hasClassbookEntry
                    ? 'status-button status-button--ok'
                    : 'status-button status-button--missing'
                "
                [pTooltip]="
                  entry.hasClassbookEntry
                    ? 'Klassenbuch-Eintrag vorhanden — weiteren Eintrag hinzufügen'
                    : 'Klassenbuch-Eintrag fehlt — jetzt eintragen'
                "
                tooltipPosition="right"
                (onClick)="classbookRequested.emit(entry)"
              ></p-button>
            }
          </div>
        </td>
      }
      <td>
        <!-- Ohne 'de-DE' käme "Wed": die App setzt kein LOCALE_ID -->
        <div>{{ entry.date | date: "EE dd.MM.yyyy" : null : "de-DE" }}</div>
        @if (entry.showSlot) {
          <span class="slot-badge">{{ slotLabel(entry.slot) }}</span>
        }
      </td>
      <td>
        @if (timeRangeLabel(entry); as range) {
          {{ range }}
        } @else {
          <span class="muted">-</span>
        }
      </td>
      <td>{{ entry.courseName }}</td>
      <td>
        @if (entry.topic) {
          {{ entry.topic }}
        } @else {
          <span class="muted">-</span>
        }
      </td>
      <td>
        <app-docent-timetable-meeting-actions
          [entry]="entry"
          [canEdit]="canEditMeetings"
          [lecturerUsers]="lecturerUsers"
          (meetingChanged)="meetingChanged.emit()"
        ></app-docent-timetable-meeting-actions>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="showClassbook ? 7 : 6">{{ emptyMessage }}</td>
    </tr>
  </ng-template>
</p-table>
